// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyClaimSearchResponseModel {
    static getAttributeTypeMap() {
        return PharmacyClaimSearchResponseModel.attributeTypeMap;
    }
}
PharmacyClaimSearchResponseModel.discriminator = undefined;
PharmacyClaimSearchResponseModel.attributeTypeMap = [
    {
        "name": "claim",
        "baseName": "claim",
        "type": "ClaimPharmacyClaimModel"
    },
    {
        "name": "claimDetails",
        "baseName": "claimDetails",
        "type": "ClaimDetailsResponseModel"
    }
];
//# sourceMappingURL=pharmacyClaimSearchResponseModel.js.map